import { primaryNavigation } from "../knowledge/navigationModel.js";
import { LucideIcon } from "./lucideIconMap.js";

export function PrimarySidebar({ activePrimaryId, onSelect }) {
  return (
    <aside className="sidebar">
      <div className="brand">
        <span className="brand-mark">S</span>
        <div>
          <strong>Strategy</strong>
          <span>Evidence-gated OS</span>
        </div>
      </div>

      <nav className="domain-nav" aria-label="Primary navigation">
        {primaryNavigation.map((item) => (
          <button
            key={item.id}
            className={item.id === activePrimaryId ? "active" : ""}
            onClick={() => onSelect(item)}
            title={item.description}
          >
            <LucideIcon name={item.icon} size={17} />
            <span>{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="sidebar-foot">
        <span>Claim mode</span>
        <strong>Evidence first</strong>
      </div>
    </aside>
  );
}
